if (!customElements.get('hero-slideshow')) {
  class HeroSlideshow extends HTMLElement {
    constructor() {
      super();

      this.swiperInit();
      this.chromeBlurFix();

      window.addEventListener('resize', () => {
        this.chromeBlurFix();
      });
    }

    swiperInit() {
      const swiperElement = this.querySelector('[data-swiper]');

      if (!swiperElement) { return; }

      const pagination = swiperElement.querySelector('[data-swiper-pagination]');
      const autoplayEnabled = this.getAttribute('data-slideshow-autoplay') === 'true';
      const autoplayDelay = parseInt(this.getAttribute('data-slideshow-autoplay-delay'), 10) || 6000;
      const autoplayDelayStyleValue = autoplayEnabled ? autoplayDelay : 0;
      const swiperOptions = {
        spaceBetween: 0,
        slidesPerView: 1,
        autoHeight: true,
        simulateTouch: true,
        allowTouchMove: true,
        threshold: 20,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: pagination,
          clickable: true
        }
      };

      if (autoplayEnabled) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false
        };
      }

      swiperElement.style.setProperty('--swiper-autoplay-delay', `${autoplayDelayStyleValue}ms`);

      const swiper = new window.Swiper(swiperElement, swiperOptions);

      return swiper;
    }

    chromeBlurFix() {
      const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      const heroImageBlur = this.querySelector('[data-hero-image-blur]');

      if (!isChrome || !heroImageBlur) { return; }

      heroImageBlur.style['z-index'] = 9;

      setTimeout(() => {
        heroImageBlur.style['z-index'] = 10;
      }, 1);
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);
}